import { render } from "./index.vue?vue&type=template&id=32f2f831&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32f2f831&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=32f2f831&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f2f831"]])

export default __exports__